<template>
  <div class="audioAni"   @click.stop="audioManager">
    <div class="ani-audio  music-play" :class="{'static-audio':!audioPlay}">
      <span class="line line1" style="animation-delay: 0.1s;"></span>
      <span class="line line2" style="animation-delay: 0.2s;"></span>
      <span class="line line3" style="animation-delay: 0.3s;"></span>
      <span class="line line4" style="animation-delay: 0.4s;"></span>
      <span class="line line5" style="animation-delay: 0.5s;"></span>
    </div>
  </div>
</template>

<script>
import { mapState,mapGetters,mapMutations } from 'vuex';
export default {
  name: 'sAudioAni',
  props: {playInfo:Object },
  data(){
    return{
       
    }
  },
  watch:{
    playInfo:{
      handler(newv,oldv){
        if(newv){
          this.playAudio(); 
        }
      },immediate:true
    }
  },
  computed:{
    ...mapGetters("audio", {
      audioPercent: "getPercent",
      curPlay: 'getCurAudio',
    }),
    ...mapState("audio",{
      audioPlay:"playState",
    })
  },
  methods:{
    ...mapMutations(['audio/updatePlayInfo','audio/updatePlayState']),
    audioManager(){
      if(this.audioPlay){
        this['audio/updatePlayState'](false)
      }else{
        this['audio/updatePlayState'](true)
      }
    },

    // 播放音频
    playAudio(){

      this['audio/updatePlayInfo'](this.playInfo)
      this['audio/updatePlayState'](true)
    },
  },
}
</script>
<style scoped lang="scss">
  .audioAni{
    width: 30rem;
    height: 30rem;
    background: rgba($color: #000000, $alpha: 0.5);
    border-radius: 20rem;
    display: flex;
    align-items: center;
    justify-content: center;
    .line{
      background-color: #fff;
    }
    .music-play{
      height: 14rem;
    }
    .music-play.static-audio{
      align-items: center;
      span{
        animation: none;
        &.line1{ height: 4rem; }
        &.line2{ height: 8rem; }
        &.line3{ height: 14rem; }
        &.line4{ height: 8rem; }
        &.line5{ height: 4rem; }
      }
    }
  }

</style>